import { Zoom } from '@mui/material';
import logo from 'assets/images/logo.png';
import { useEffect, useState } from 'react';
import './Splashscreen.scss';

export type SplashscreenProps = {
  onClose: () => void;
};

export const Splashscreen = () => {
  const [animate, setAnimate] = useState(true);
  useEffect(() => {
    setTimeout(() => setAnimate(false), 5000);
  }, []);

  return (
    <Zoom in={animate}>
      <div className="splash-screen position-fixed d-flex flex-column align-items-center justify-content-center w-100 h-100">
        <div className="d-flex flex-column align-items-center">
          <img src={logo} alt="InspectSmart" />
          <span className="tagline">Explore Digital Inspections</span>
        </div>
      </div>
    </Zoom>
  );
};
